module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_1_R.72627bc8.jpg";